var state = {
    cognitoInfo: {},
    token: '',
    loggedIn: false,
    loadingState: true,
    errorLoadingState: false
}

function setLoggedIn(newValue) {
    state.loggedIn = newValue
}

function setLoggedOut() {
    state.loggedIn = false
    state.token = ''
    state.cognitoInfo = {}
    console.log('saved lo', state)
    localStorage.setItem('recipelogin', JSON.stringify(state))
}

function setCognitoInfo(newValue) {
    state.cognitoInfo = newValue
}

function setToken(newValue) {
    state.token = newValue
    console.log('saved token', state)
    localStorage.setItem('recipelogin', JSON.stringify(state))
}

function load() {
    state = JSON.parse(localStorage.getItem('recipelogin'))
    console.log('loaded', state)
}

function getToken() {
    return state.token
}

export default {
    state: state,
    setLoggedIn: setLoggedIn,
    setLoggedOut: setLoggedOut,
    setCognitoInfo: setCognitoInfo,
    setToken: setToken,
    getToken: getToken,
    load: load,
}
